var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../public/images/article/activity.jpg")}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../public/images/article/btn.jpg")},on:{"click":_vm.init}})])
}
var staticRenderFns = []

export { render, staticRenderFns }